var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inRefiningTreasure
    ? _c(
        "div",
        { staticClass: "treasure-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "treasure-card",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "treasure-content" }, [
                !_vm.gameState.refiningItemName
                  ? _c("div", { staticClass: "selection-section" }, [
                      _c("h4", [_vm._v("选择要炼制的法宝")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "treasure-list" },
                        _vm._l(_vm.refinableTreasures, function (treasure) {
                          return _c(
                            "button",
                            {
                              key: treasure,
                              staticClass: "treasure-button",
                              on: {
                                click: function ($event) {
                                  return _vm.selectTreasure(treasure)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(treasure) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _c("div", { staticClass: "recipe-section" }, [
                      _c("div", { staticClass: "recipe-header" }, [
                        _c("h4", [
                          _vm._v(
                            "选择配方：" +
                              _vm._s(_vm.gameState.refiningItemName)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "recipe-controls" }, [
                          _c(
                            "button",
                            {
                              staticClass: "back-btn",
                              on: { click: _vm.backToSelection },
                            },
                            [_vm._v("返回选择")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "auto-fill-btn",
                              attrs: { disabled: _vm.isProcessing },
                              on: { click: _vm.autoFillMaterials },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.autoFillText) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "refine-btn",
                              attrs: {
                                disabled: !_vm.canRefine || _vm.isProcessing,
                              },
                              on: { click: _vm.refineTreasure },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.refineBtnText) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", [_vm._v("所需材料")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "recipe-materials" },
                        _vm._l(_vm.recipe.ingredients, function (ingredient) {
                          return _c(
                            "div",
                            {
                              key: ingredient.item,
                              staticClass: "material-item",
                            },
                            [
                              _c("span", { staticClass: "material-name" }, [
                                _vm._v(_vm._s(ingredient.item)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "material-required" }, [
                                _vm._v("需要: " + _vm._s(ingredient.count)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "material-owned" }, [
                                _vm._v(
                                  "拥有: " +
                                    _vm._s(
                                      _vm.ownedMaterials[ingredient.item] || 0
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "material-inputs" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value:
                                        _vm.selectedMaterials[ingredient.item],
                                      expression:
                                        "selectedMaterials[ingredient.item]",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "material-input",
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max:
                                      _vm.ownedMaterials[ingredient.item] || 0,
                                    placeholder: "0",
                                  },
                                  domProps: {
                                    value:
                                      _vm.selectedMaterials[ingredient.item],
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.selectedMaterials,
                                        ingredient.item,
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "add-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.addMaterial(
                                          ingredient.item,
                                          1
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("+")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "remove-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeMaterial(
                                          ingredient.item,
                                          1
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("-")]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                _vm._v(" "),
                _vm.statusMessage
                  ? _c("div", { staticClass: "status-message" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.statusMessage) + "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "treasure-footer" }, [
                _c(
                  "button",
                  { staticClass: "close-btn", on: { click: _vm.closeModal } },
                  [_vm._v("关闭")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "treasure-header" }, [
      _c("h3", [_vm._v("炼器炉")]),
      _vm._v(" "),
      _c("p", [_vm._v("选择法宝配方，放入材料进行炼制。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }